/**
 * File cta-cards.js.
 * Handles logic for the CTA Cards module.
 */

const ctaModalTrigger = document.querySelectorAll('.cta-cards__modal-trigger');
const ctaModalClose = document.querySelectorAll('.cta-cards__modal-close');
let ctaBtn;
let ctaCardsModal;
let ctaCardsCta;
let ctaCardsCtaHref;
let ctaCardsModule;

const closeCtaModal = (e) => {
  hideModal(e.target.closest('.cta-cards__modal'));
}

const showAcknowledgement = (e) => {
  e.preventDefault();
  e.stopImmediatePropagation();

  ctaBtn = e.target;
  ctaCardsModule = ctaBtn.closest('.cta-cards');
  ctaCardsCtaHref = ctaBtn.getAttribute('href');
  ctaCardsModal = ctaCardsModule.querySelector('.cta-cards__modal');
  ctaCardsCta = ctaCardsModal.querySelector('.cta-cards__modal-cta');

  if (ctaCardsCta) {
    ctaCardsCta.setAttribute('href', ctaCardsCtaHref);
    ctaCardsCta.addEventListener('click', closeCtaModal);
  }

  if (ctaCardsModal) {
    showModal(ctaCardsModal);
  }
};

if (ctaModalTrigger.length > 0) {
  ctaModalTrigger.forEach((trigger) => {
    trigger.addEventListener('click', showAcknowledgement);
  });
}

if (ctaModalClose.length > 0) {
  ctaModalClose.forEach((close) => {
    close.addEventListener('click', closeCtaModal);
  });
}
